import { computed, ComputedRef, Ref } from "vue";
import { LotDTO } from "seedgreen-shared/dtos/LotDTO";
import { Position } from "geojson";
import { useI18n } from "vue-i18n";

// distanceTo() returns kilometers (turf default); we display imperial,
// consistent with the map scale control in useMapboxControls.ts
const KM_TO_MILES = 0.621371;

/**
 * Get a method for display a field based on a given Lot object
 */
export function useLotDisplayField(
	key: Ref<LotDisplayFieldKey>,
): ComputedRef<LotDisplayField> {
	const { t } = useI18n();
	LotDisplayFields.distance.label = t("lot-search.distance");
	LotDisplayFields.grower.label = t("planting-details.grower");
	return computed(() => LotDisplayFields[key.value]);
}

export interface LotDisplayField {
	fn: (
		lot: LotDTO,
		userPosition: Position | undefined,
		t: (key: string) => string,
	) => string;
	label: string;
}
export const LotDisplayFields = {
	distance: {
		label: "Distance",
		fn: (lot, userPosition, t) => {
			if (!lot.boundary || !userPosition) return "";
			const dist = lot.distanceTo(userPosition);
			if (dist === undefined) return t("common.unknown");
			return (
				(dist * KM_TO_MILES).toFixed(1) + " " + t("measure.mile-abv")
			);
		},
	},
	grower: {
		label: "Grower",
		fn: (lot) => {
			return lot.growerName ?? "";
		},
	},
} satisfies Record<string, LotDisplayField>;
export type LotDisplayFieldKey = keyof typeof LotDisplayFields;
